export function chronopostTrackingUrl(ref: string): string {
  return `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${encodeURIComponent(ref)}`;
}
